module.exports = __webpack_public_path__ + "media/images/lb/047-aff67d7e974c888bdf7686e47c58c39b.svg";